import { AfterViewInit, Component, ElementRef, Input, Renderer2, ViewChild } from "@angular/core";

@Component({
    selector: 'pv-spinner',
    templateUrl: './pv-spinner.component.html',
    styleUrls: ['./pv-spinner.component.scss'],
    host: {
        class: 'pv-spinner'
    },
})
export class PvSpinnerComponent implements AfterViewInit {
    @ViewChild('spinnerIcon', { static: true, read: ElementRef }) svgElement!: ElementRef;

    @Input()
    message: string;

    @Input()
    fill: string;

    @Input()
    iconRef: string = 'culteva:icon';

    constructor(private _renderer: Renderer2) { }

    ngAfterViewInit(): void {
        const svg = this.svgElement.nativeElement.querySelector('svg');

        if (!svg) return;

        const path = svg.querySelector('path');

        if (!path) return;

        this._renderer.setStyle(path, 'fill', this.fill);
    }
}